export default __webpack_public_path__ + "static/no-code-mobile-6833891d74174066c27f5a61f4529522.svg";